import { TUIDialog } from "@/types";

export default class UIDialog {
    public title: string;
    public callBack: any;
    public type: TUIDialog;
    public initData: any;
    public message: string;
    public okButton: string;
    public cancelButton: string;

    constructor(
        title: string,
        callBack: any,
        type?: TUIDialog,
        initData?: any,
        message?: string,
        okButton?: string,
        cancelButton?: string
    ) {
        this.title = title;
        this.callBack = callBack;
        this.type = type ?? 'default';
        this.initData = initData;
        this.message = message ?? '';
        this.okButton = okButton ?? 'Підтвердити';
        this.cancelButton = cancelButton ?? 'Скасувати';
    }
}